import React from 'react';

import styles from './styles.scss';

export default class FieldErrors extends React.Component {

    render() {
        return (
            <ul>
                {
                    this.props.errors.map((e, i) => {
                        return <li key={i} className={styles.error}>{e}</li>
                    })
                }
            </ul>
        )
    }
}